<template>
  <div>
    <div class="mgt-20px">
      <info-ot-consultation :ordreTravail="ordreTravail">
      </info-ot-consultation>
    </div>
    <div class="mgt-20px">
      <annonceur :ordreTravail="ordreTravail">
        <template #otherAction v-if="moduleAffixeMobileOTAffichageActive">
          <div class="mgr-2">
            <b-checkbox-button
              v-model="withoutImage"
              @input="$emit('getFacesLogo', $event)"
              type="is-primary"
              outlined>
              <b-icon :icon="withoutImage ? 'image-off-outline' : 'image-outline'" class="mg-0">
              </b-icon>
            </b-checkbox-button>
          </div>
        </template>
      </annonceur>
    </div>
    <div class="mgt-20px">
      <table class="VueTables__table table is-bordered is-fullwidth">
        <thead>
        <th v-if="!withoutImage">{{ $t('detailOrdreTravailAffichage.tab.image') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.panneaux') }}</th>
        <th></th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.faces') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.pose')}}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.commentaire') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.restriction') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.affichagePrecedent') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.affichageEffectue') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.laisserEnPlace') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.grattage') }}</th>
        </thead>
        <tbody>
        <tr v-for="(face, index) in facesOtSort" :key="index"
          :class="face.pairImpair">
          <td v-if="!withoutImage">
            <image-view
              :permission="constantes.permsCommandes"
              :image="face.cheminMin"
              :imageTooltip="face.chemin"
              :id="face.id"
              :libelle="face.produitReference || ' '"
              :maxSize="true"
            />
          </td>
          <td :rowspan="getNumberRowToSpan(face.materielId, index)"
              v-if="!isSameDispositif(index - 1, face.materielId)"
              :class="{'has-background-light-orange': face.ajoutApresCreation}">
            <p class="has-text-link is-size-5 has-text-weight-bold">
              {{ $t('detailOrdreTravailAffichage.tab.panneau', { code : face.materielCode }) }}
            </p>
            <p class="has-text-default">
              {{ adressFullStringGetter(face.dispositifAdresse) }}
            </p>
            <div class="columns mgt-5px">
              <div class="column is-4">
                <b-field :label="$t('detailOrdreTravailAffichage.tab.format')"
                         custom-class="has-text-weight-bold is-marginless">
                  <p class="has-text-default">{{ face.format }}</p>
                </b-field>
              </div>
              <div class="column is-4">
                <b-field :label="$t('detailOrdreTravailAffichage.tab.nbFaces')"
                         custom-class="has-text-weight-bold is-marginless">
                  <p class="has-text-default">
                    {{ face.materielNbFace }}
                  </p>
                </b-field>
              </div>
              <div class="column is-4">
                <b-field :label="$t('detailOrdreTravailAffichage.tab.disposition')"
                         custom-class="has-text-weight-bold is-marginless">
                  <p class="has-text-default">
                    {{ face.materielDisposition }}
                  </p>
                </b-field>
              </div>
            </div>
          </td>
          <td :class="getBackgroundColor(face)"
              class="vertical-alignment has-text-centered">
            <b-icon :icon="getIcon(face)"
                    type="is-link" size="is-medium"></b-icon>
          </td>
          <td :class="{'has-background-light-orange': face.ajoutApresCreation}">
            <router-link
              target="_blank"
              :to="{ name: 'c.bodac.catalogue-face', params: { id: face.produitId } }"
              class="lien"
              :class="{'text-access-no-permission':
              !checkPermissions(constantes.permCatalogue.lecture)}">
            <span>{{ $t('detailOrdreTravailAffichage.tab.faceNb') }}</span>
            <span class="has-text-weight-bold">{{ face.produitReference }}</span>
            </router-link>
          </td>
          <td>
            <router-link-blank v-if="face.affectationLogistiqueCommandeId"
              :to="{ name: 'c.bodac.commandes',
              params: { id: face.affectationLogistiqueCommandeId  }}"
              :class="{'text-access-no-permission':
                     !checkPermissions(constantes.permsCommandes.lecture)}"
              :message="face.pose"/>
            <span v-else>{{ face.pose}}</span>
          </td>
          <td> {{ face.instructionPose }} </td>
          <td> {{ face.restrictionsAffichage }} </td>
          <td> {{ face.affichagePrecedent }} </td>
          <td class="vertical-alignment">
            <div class="columns">
              <div class="column is-2 mg-auto has-text-centered">
                <b-icon :icon="face.affichage ? 'check-circle' : 'close-circle'"
                        size="mdi-24px"
                        :type="face.affichage ? 'is-success' : 'is-danger'"></b-icon>
              </div>
              <div class="column is-10 mg-auto">
                <p v-if="face.commentaireAffichage" >
                  {{ face.commentaireAffichage}}
                </p>
              </div>
            </div>
          </td>
          <td class="vertical-alignment">
            <div class="columns">
              <div class="column is-2 mg-auto has-text-centered">
                <b-icon :icon="face.laisserEnPlace ? 'check-circle' : 'close-circle'"
                        size="mdi-24px"
                        :type="face.laisserEnPlace ? 'is-success' : 'is-danger'"></b-icon>
              </div>
              <div class="column is-10 mg-auto">
                <p v-if="face.commentaireLaisserEnPlace" >
                  {{ face.commentaireLaisserEnPlace}}
                </p>
              </div>
            </div>
          </td>
          <td class="vertical-alignment">
            <div class="has-text-centered" v-if="face.grattage">
              <b-icon icon="check-circle" size="mdi-24px"
                      type="is-success"></b-icon>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import infoOtConsultation from '@/components/logistique/ordreTravail/affichage/InfoOtConsultation';
import annonceur from '@/components/logistique/ordreTravail/affichage/annonceur';
import { ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import { LIST_ICON_AND_COLOR } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { getBackgroundColor, getIcon } from '@/services/logistique/ordreTravail/affichage/getIconAndBackgroundColorTabOt';
import { CATALOGUE, COMMANDES } from '@/configuration/permissionsBodacConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import imageView from '@/components/general/imageView';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { sortBy } from 'lodash';

const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'ordreTravailConsultation',
  data() {
    return {
      permOrdreTravail: ORDRE_TRAVAIL,
      constantes: {
        LIST_ICON_AND_COLOR: LIST_ICON_AND_COLOR,
        permCatalogue: CATALOGUE,
        permsCommandes: COMMANDES,
      },
      withoutImage: true,
    };
  },
  props: {
    ordreTravail: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleAffixeMobileOTAffichageActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.affixeMobileOTAffichage.key);
    },
    facesOtSort() {
      return sortBy(this.ordreTravail.faces, ['ordre', 'materielCode', 'produitReference']);
    },
  },
  components: {
    infoOtConsultation,
    annonceur,
    routerLinkBlank,
    imageView,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    getIcon(face) {
      return getIcon(face);
    },
    getBackgroundColor(face) {
      return getBackgroundColor(face);
    },
    adressFullStringGetter(adresse) {
      return adressFullStringGetter(adresse, false);
    },
    getNumberRowToSpan(materielId, actualIndex) {
      let nombreDeColonneAFusionnerDansLeTableau = 0;
      for (let i = actualIndex; i < this.facesOtSort.length; i += 1) {
        if (materielId === this.facesOtSort[i].materielId) {
          nombreDeColonneAFusionnerDansLeTableau += 1;
        } else break;
      }
      return nombreDeColonneAFusionnerDansLeTableau;
    },
    isSameDispositif(index, actualDispositif) {
      return index < 0 ? false : this.facesOtSort[index].materielId === actualDispositif;
    },
  },
  async mounted() {
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.affixeMobileOTAffichage.key,
      ]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
